/**
 * Icône de l'assistant Noa : le « O » du logo NOA (cercle ouvert + segment accent).
 * Les arcs principaux suivent currentColor ; le segment accent est atténué pour
 * rester lisible sur fond de marque comme sur fond clair.
 */
export function NoaIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="140 -7 154 154"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <path
        fill="currentColor"
        d="M257.74,62.37h28.86C283.28,29.59,257.22,3.3,224.33,0v28.94c16.81,3.14,30.38,16.54,33.41,33.42Z"
      />
      <path
        fill="currentColor"
        d="M217.18,110.88c-22.76,0-41.25-18.68-41.25-41.45,0-20.13,14.72-37.09,34.05-40.54V0c-35.39,3.7-62.65,33.56-62.65,69.43,0,38.72,31.13,69.86,70.05,69.86,16.84,0,32.23-6,44.26-15.94l-20.58-20.24c-6.75,4.85-14.96,7.77-23.88,7.77Z"
      />
      <path
        fill="currentColor"
        opacity="0.45"
        d="M257.74,76.71c-1.05,5.91-3.36,11.39-6.64,16.16l20.6,20.26c8.14-10.17,13.47-22.68,14.88-36.41h-28.85Z"
      />
    </svg>
  );
}
